// extracted by mini-css-extract-plugin
module.exports = {"remove":"styles_remove__1Dz0V"};